import { ScannerAccount as ScannerAccountComponent } from 'features/ScannerAccount';

const ScannerAccountPage = (): JSX.Element => {
	return <ScannerAccountComponent />;
};
export default ScannerAccountPage;
